<template lang="pug">
  .sud-toolbar-item
    span.mr-2(v-if="label") {{ label | upFirstLetter }}

    // Меню
    v-menu(open-on-hover offset-y content-class="sud-toolbar-menu" nudge-bottom="10" close-delay="300" allow-overflow)

      // Меню - Активатор
      template(v-slot:activator="{ on }")
        .sud-toolbar-item__activator.text-lowercase(:style="{ minWidth: minWidth ? minWidth + 'px' : 'min-content' }" v-on="on")
          slot

      // Меню - Контент
      slot(name="menu")
        v-list.p-0.sud-toolbar-menu__list(v-if="items && items.length > 0" dense :max-height="maxHeight" :max-width="maxWidth")
          div(v-if="all")
            v-list-item.sud-toolbar-menu__item(tag="div" inactive @click.native="handleSelect(null, -1)")
              .sud-toolbar-menu__item-content.text-lowercase {{ all }}
          div.sud-toolbar-menu__list(v-for="(item, index) in items" :key="index")
            v-divider.mx-4(dark v-if="item.divider")
            v-list-item.sud-toolbar-menu__item(v-else tag="div" inactive @click.native="handleSelect(item, index)")
              .sud-toolbar-menu__item-content
                slot(name="list-item" :item="item" :index="index") 
                  v-icon(v-if="item['prepend-icon']" dark left) {{ item['prepend-icon'] }}
                  span(v-if="itemPrefix") {{ itemPrefix }}
                  span.text-lowercase {{ keyName ? item[keyName] : item }}
    slot(name="append")
</template>

<script>
export const AppToolbarItemDivider = {
  divider: true
}

export default {
  inheritAttrs: false,
  name: 'app-toolbar-item',
  props: {
    label: String,
    items: Array,
    keyName: String,
    all: String,
    minWidth: {
      type: [String, Number],
      default: 120
    },
    maxWidth: [String, Number],
    maxHeight: [String, Number],
    itemPrefix: String
  },
  methods: {
    handleSelect (item, index) {
      if (item && item.action) {
        item.action()
      }
      this.$emit('select', item, index)
    }
  },
  filters: {
    upFirstLetter (str) {
      return str[0].toUpperCase() + str.slice(1)
    }
  }
}
</script>

<style lang="css">
.sud-toolbar-item {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 18px;

  color: #F2F2F2;
}
.sud-toolbar-item__activator {
  padding: 0px 8px;
  background: rgba(80, 82, 84, 0.4);
  border-radius: 5px;

  font-weight: normal;
  
  height: 24px;
  line-height: 24px;
  display: inline-block;
}

.sud-toolbar-menu {
  border-radius: 0px 0px 5px 5px !important;
}
.sud-toolbar-menu__list {
  background: #757575 !important;
}
.sud-toolbar-menu__item {
  padding-left: 24px;
}
.sud-toolbar-menu__item:hover {
  background: rgba(80, 82, 84, 0.4) !important;
}
.sud-toolbar-menu__item-content {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #FFFFFF;
}
</style>
